export function privateTaskSupportingText({
  hasDistinctAssignee,
  privateTeamVisibilityEnabled = false,
  hasSelectedTeams = false
}: {
  hasDistinctAssignee: boolean;
  privateTeamVisibilityEnabled?: boolean;
  hasSelectedTeams?: boolean;
}): string {
  if (privateTeamVisibilityEnabled && hasSelectedTeams) {
    return hasDistinctAssignee
      ? "Only you, the assignee, and selected Teams can view this task"
      : "Only you and selected Teams can view this task";
  }

  return hasDistinctAssignee ? "Only you and the assignee can view this task" : "Only you can view this task";
}

export function teamVisibilitySupportingText(privateTeamVisibilityEnabled: boolean): string {
  return privateTeamVisibilityEnabled
    ? "Listed on Department Tasks; members can also view private tasks"
    : "Listed on Department Tasks; private visibility unchanged";
}

export function hasDistinctPrivateAssignee(
  assigneeId: string | null | undefined,
  currentUserId: string | null | undefined
): boolean {
  return Boolean(assigneeId && currentUserId && assigneeId !== currentUserId);
}
